import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames';
import DynamicIcon from './DynamicIcon';
import { makeStyles } from '@material-ui/core/styles';

import ListItem from '@material-ui/core/ListItem';
import Badge from '@material-ui/core/Badge';
import Tooltip from '@material-ui/core/Tooltip';
import { setFilter, setPegueFilter} from '../state/order/actions'

const useStyles = makeStyles((theme) => ({
  icon: {
    minWidth: 32,
    minHeight: 32,
  },
  customTooltip: {
    fontSize: 18
  },
  listItem: {
    borderLeft: 4,
    borderColor: 'transparent',
    borderLeftStyle: 'solid',
    width: '54px',
    margin: '0 8px',
    padding: '10px 8px',
    height: '12%',
    minHeight: '60px',
    borderRadius: 4,
    '&.is-active': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)'
    },
    '&.new-orders:hover, &.new-orders.is-active': {
      borderColor: theme.palette.pages['new-orders'],
    },
    '&.dashboard:hover, &.dashboard.is-active': {
      borderColor: theme.palette.pages['dashboard'] || '#757575',
    },
    '&.estimated:hover, &.estimated.is-active': {
      borderColor: theme.palette.pages['estimated'],
    },
    '&.picking:hover, &.picking.is-active': {
      borderColor: theme.palette.pages['picking'] || '#00CBFF',
    },
    '&.ready-to-go:hover, &.ready-to-go.is-active': {
      borderColor: theme.palette.pages['ready-to-go'] || '#FFAA00',
    },
    '&.shipping:hover, &.shipping.is-active': {
      borderColor: theme.palette.pages['shipping'] || '#CE00FF',
    },
    '&.returning-to-storage:hover, &.returning-to-storage.is-active': {
      borderColor: theme.palette.pages['returning-to-storage'] || '#B72F2C',
    },
    '&.history:hover, &.history.is-active': {
      borderColor: theme.palette.pages['history'] || '#757575',
    }
  },
  badge: {
    top: `-${theme.spacing(2)}px`,
    right: 4,
    '& > span': {
      color: 'white',
      right: theme.spacing(2),
      top: `-${theme.spacing(1)}px`,
      zIndex: 99,
    },
    '&.new-orders > span': {
      backgroundColor: theme.palette.pages['new-orders'] || '#12CD0B',
    },
    '&.dashboard > span': {
      backgroundColor: theme.palette.pages['dashboard'] || '#757575',
    },
    '&.estimated > span': {
      backgroundColor: theme.palette.pages['estimated'],
    },
    '&.picking > span': {
      backgroundColor: theme.palette.pages['picking'] || '#00CBFF',
    },
    '&.ready-to-go > span': {
      backgroundColor: theme.palette.pages['ready-to-go'] || '#FFAA00',
    },
    '&.shipping > span': {
      backgroundColor: theme.palette.pages['shipping'] || '#CE00FF',
    },
    '&.returning-to-storage > span': {
      backgroundColor: theme.palette.pages['returning-to-storage'] || '#B72F2C',
    },
    '&.history > span': {
      backgroundColor: theme.palette.pages['history'] || '#757575',
    }
  },
}));

export default function MainListItem(props) {
  const { nav, isActive, goToRoute } = props;
  const state = useSelector(state => state.orders.totals);
  const classes = useStyles();
  const dispatch = useDispatch()
  const badgeNum = nav.status.reduce((ac, cv) => {
    if(!state) return ac;
    const a = state.find(val => val._id === cv);
    if (a) {
      ac += a.count;
    }
    return ac;
  }, 0);

  const resetMinDiasAndRedirect = (url) => {
    dispatch(setFilter('minDias',0))
    dispatch(setPegueFilter(20))
    goToRoute(url)
  }

  return (
    <Tooltip
      classes={{ tooltip: classes.customTooltip }}
      title={nav.title}
      placement="right">

      <ListItem className={classNames(classes.listItem, isActive(nav.url), nav.id)} button onClick={() => resetMinDiasAndRedirect(nav.url)} >
        <DynamicIcon list icon={nav.icon} className={classes.icon} />
        <Badge badgeContent={badgeNum} max={9999} className={classNames(classes.badge, nav.id)}></Badge>
      </ListItem>
    </Tooltip>
  );
}
